import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';

export interface IAddServiceAccountCredentialRequest {
   text: string;
   dbClass: string;
}

export interface IAddServiceAccountCredentialResult extends IResult {
  id: string;
}

export class AddServiceAccountCredentialRequest extends Request<IAddServiceAccountCredentialRequest, IAddServiceAccountCredentialResult> {
  constructor(params: IAddServiceAccountCredentialRequest) {
    super('addServiceAccountCredential', params);
  }
}